import {
    DE,
    DE_AT,
    EN_AU,
    EN_IN,
    EN_SG,
    EN_UK,
    EN_US,
    ES_ES,
    FR_FR,
    IT,
    NL_NL,
    NL_BE,
    ZH_HANS,
    EN,
    FR,
    FR_BE,
    ES_US,
    ES,
} from '../constants/languageCode';

export const getPressInformationUrl = (language: string): string => {
    switch (language) {
        case DE:
            return 'presseinformationen';
        case DE_AT:
            return 'presseinformationen';
        case EN_AU:
            return 'press-information';
        case EN_IN:
            return 'press-information';
        case EN_SG:
            return 'press-information';
        case EN_UK:
            return 'press-information';
        case EN_US:
            return 'press-information';
        case ES_ES:
            return 'prensa';
        case FR_FR:
            return 'presse';
        case IT:
            return 'ultime-novita';
        case NL_NL:
            return 'persberichten';
        case NL_BE:
            return 'persberichten';
        case ZH_HANS:
            return 'press-information';
        case EN:
            return 'press-information';
        case FR:
            return 'presse';
        case FR_BE:
            return 'presse';
        case ES_US:
            return 'prensa';
        case ES:
            return 'prensa';
        default:
            return 'presseinformationen';
    }
};
